module.exports = __webpack_public_path__ + "crossdomain.xml";


//////////////////
// WEBPACK FOOTER
// ./src/static/crossdomain.xml
// module id = 16
// module chunks = 0